import { Card } from '../../../components/ui/Card';
import type { AdminTicketCounts } from '../../../domain/superadmin/types';
import { cn } from '@/lib/utils';

type KpiKey = 'open' | 'in_progress' | 'resolved';

const KPI_ITEMS: { key: KpiKey; label: string }[] = [
    { key: 'open', label: 'Abertos' },
    { key: 'in_progress', label: 'Em andamento' },
    { key: 'resolved', label: 'Resolvidos' },
];

interface AdminTicketKpisProps {
    counts: AdminTicketCounts;
    activeStatus: string;
    onStatusClick: (status: string) => void;
}

export function AdminTicketKpis({ counts, activeStatus, onStatusClick }: AdminTicketKpisProps) {
    return (
        <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {KPI_ITEMS.map(({ key, label }) => {
                const isActive = activeStatus === key;
                return (
                    <button
                        key={key}
                        type="button"
                        onClick={() => onStatusClick(isActive ? '' : key)}
                        className="text-left"
                    >
                        <Card
                            className={cn(
                                'transition-colors',
                                isActive && 'ring-2 ring-primary/40'
                            )}
                        >
                            <p className="text-sm text-text-secondary">{label}</p>
                            <p className="mt-2 text-2xl font-semibold text-secondary">
                                {counts[key].toLocaleString('pt-BR')}
                            </p>
                        </Card>
                    </button>
                );
            })}
        </div>
    );
}
